import { render, staticRenderFns } from "./BossPrice.vue?vue&type=template&id=62624bdc&scoped=true&"
import script from "./BossPrice.vue?vue&type=script&lang=js&"
export * from "./BossPrice.vue?vue&type=script&lang=js&"
import style0 from "./BossPrice.vue?vue&type=style&index=0&id=62624bdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62624bdc",
  null
  
)

export default component.exports